/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetAllGroupsQuery = { __typename?: 'Query', getAllGroups: Array<{ __typename?: 'GroupModel', group_id: string, group_name: string }> };

export type UpdateGroupMutationVariables = Types.Exact<{
  input: Types.UpdateGroupInput;
}>;


export type UpdateGroupMutation = { __typename?: 'Mutation', updateGroup: { __typename?: 'GroupModel', group_id: string, group_name: string } };

export type SendGroupEmailInviteMutationVariables = Types.Exact<{
  input: Types.SendGroupInviteInput;
}>;


export type SendGroupEmailInviteMutation = { __typename?: 'Mutation', sendGroupEmailInvite: boolean };


export const GetAllGroupsDocument = gql`
    query getAllGroups {
  getAllGroups {
    group_id
    group_name
  }
}
    `;
export function useGetAllGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllGroupsQuery, GetAllGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllGroupsQuery, GetAllGroupsQueryVariables>(GetAllGroupsDocument, options);
      }
export function useGetAllGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllGroupsQuery, GetAllGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllGroupsQuery, GetAllGroupsQueryVariables>(GetAllGroupsDocument, options);
        }
// @ts-ignore
export function useGetAllGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAllGroupsQuery, GetAllGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllGroupsQuery, GetAllGroupsQueryVariables>;
export function useGetAllGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllGroupsQuery, GetAllGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAllGroupsQuery | undefined, GetAllGroupsQueryVariables>;
export function useGetAllGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllGroupsQuery, GetAllGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllGroupsQuery, GetAllGroupsQueryVariables>(GetAllGroupsDocument, options);
        }
export type GetAllGroupsQueryHookResult = ReturnType<typeof useGetAllGroupsQuery>;
export type GetAllGroupsLazyQueryHookResult = ReturnType<typeof useGetAllGroupsLazyQuery>;
export type GetAllGroupsSuspenseQueryHookResult = ReturnType<typeof useGetAllGroupsSuspenseQuery>;
export type GetAllGroupsQueryResult = Apollo.QueryResult<GetAllGroupsQuery, GetAllGroupsQueryVariables>;
export const UpdateGroupDocument = gql`
    mutation updateGroup($input: UpdateGroupInput!) {
  updateGroup(input: $input) {
    group_id
    group_name
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const SendGroupEmailInviteDocument = gql`
    mutation sendGroupEmailInvite($input: SendGroupInviteInput!) {
  sendGroupEmailInvite(input: $input)
}
    `;
export type SendGroupEmailInviteMutationFn = Apollo.MutationFunction<SendGroupEmailInviteMutation, SendGroupEmailInviteMutationVariables>;
export function useSendGroupEmailInviteMutation(baseOptions?: Apollo.MutationHookOptions<SendGroupEmailInviteMutation, SendGroupEmailInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendGroupEmailInviteMutation, SendGroupEmailInviteMutationVariables>(SendGroupEmailInviteDocument, options);
      }
export type SendGroupEmailInviteMutationHookResult = ReturnType<typeof useSendGroupEmailInviteMutation>;
export type SendGroupEmailInviteMutationResult = Apollo.MutationResult<SendGroupEmailInviteMutation>;
export type SendGroupEmailInviteMutationOptions = Apollo.BaseMutationOptions<SendGroupEmailInviteMutation, SendGroupEmailInviteMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetAllGroups = withQueryResponseHandler(useGetAllGroupsQuery);
export const useUpdateGroup = withMutationResponseHandler(useUpdateGroupMutation, "updateGroup");
export const useSendGroupEmailInvite = withMutationResponseHandler(useSendGroupEmailInviteMutation, "sendGroupEmailInvite");